Vue.asyncComponent('cms-share-modal', {
    data() {
        return {
            passwordProtected: false,
            password: null,
            expirationDate: null,
            loading: false,
            shareLink: null,
            errors: {}
        }
    },
    props: {
        open: {
            type: Boolean,
            required: true,
        },
        objectId: {
            type: String,
            required: true,
        },
        typeId: {
            type: Number|String,
            required: true
        },
        gridBundleId: {
            type: String,
        },
        gridDefinitionId: {
            type: String,
        }
    },
    model: {
        prop: 'open',
        event: 'change'
    },
    methods: {
        async generateShareLink() {
            this.loading = true;
            const path = this.$getSetting('paths.baseCms') + '/public-share-link/create';

            const params = {
                objectId: this.objectId,
                typeId: this.typeId,
            };
            const body = {
                passwordProtected: this.passwordProtected,
                password: this.password,
                expirationDate: this.expirationDate,
            };

            let result = await this.$post(path, body, params);
            this.loading = false;

            if (result.success) {
                this.shareLink = result.link;
                this.$copyToClipboard(this.shareLink);
            } else {
                this.errors = result.errors;
            }
        },
        /**
         * Open the public share link grid in a new tab
         */
        goToGrid() {
            const routeData = this.$router.resolve({
                name: 'grid',
                params: {
                    bundle: this.gridBundleId,
                    gridDefinition: this.gridDefinitionId,
                }
            });

            window.open(routeData.href, '_blank');
        }
    }
}, 'cms/share/cms-share-modal.html');